(function() {
  function initWrapper(wrapper) {
    if (!wrapper || wrapper.hasAttribute('data-dw-gem-visa-ready')) {
      return;
    }

    wrapper.setAttribute('data-dw-gem-visa-ready', 'true');
  }

  function init() {
    document.querySelectorAll('[data-dw-gem-visa]').forEach(initWrapper);
  }

  document.addEventListener('variant:change', function(event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) {
      return;
    }

    document.querySelectorAll('[data-dw-gem-visa]').forEach(function(wrapper) {
      var minimum = Number(wrapper.getAttribute('data-minimum-price')) || 25000;
      wrapper.classList.toggle('dw-gem-visa--hidden', variant.price < minimum);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
}());
